module.exports = __webpack_public_path__ + "img/standalone.3dfd2de8.svg";